
const initialState = {
    employers: [],
    error: null,
    isLoding: false
  };
  
const EmployerApiReducer =(state = initialState, action)=> {
    switch (action.type) {
        case "LOADING":
          return {
            ...state,
            isLoding: action.payload
        };

        case "GET_EMPLOYERS_SUCCESS":
            return {
                ...state,
                employers: action.payload,
                error: null
            };
        case "GET_EMPLOYERS_FAILURE":
            return {
                ...state,
                error: action.payload.error
            };
      
        case "ADD_EMPLOYER_SUCCESS":
              return {
                ...state,
                employers: [...state.employers, action.payload],
                error: null
              };
        case "ADD_EMPLOYER_FAILURE":
              return {
                ...state,
                error: action.payload.error
              };
      
        case "UPDATE_EMPLOYER_SUCCESS":
              return{
                  ...state,
                  error: action.payload.error
              };
            
        case "UPDATE_EMPLOYER_FAILURE":
              return{
                  ...state,  
                  error: action.payload.error
              };
            
        case "DELETE_EMPLOYER_SUCCESS":
              return{
                  ...state,
                  employers: state.employers.map((emp) =>
                  emp.id === action.payload.id ? action.payload : emp
                ),
                  error: null
              };
            
        case "DELETE_EMPLOYEE_FAILURE":
              return{
                  ...state,
                  error: action.payload.error
              };
              
        case "GET_ALL_EMPLOYEE_EMPLOYERS_SUCCESS":
            return {
                ...state,
                employers: action.payload,
                error: null
            };
        case "GET_ALL_EMPLOYEE_EMPLOYERS_FAILURE":
            return {
                ...state,
                error: action.payload.error
            };
        
        default:
                return state;

};
};

export default EmployerApiReducer;